export const ADDON_ID = "misskey-dev/storybook-addon-misskey-theme";
export const TOOL_ID = `${ADDON_ID}/tool`;
export const PARAM_KEY = `misskeyTheme`;

export const EVENTS = {
  RESULT: `${ADDON_ID}/result`,
  REQUEST: `${ADDON_ID}/request`,
  CLEAR: `${ADDON_ID}/clear`,
};
